<template>

    <AppHead :title="category?.name" />

    <section class="px-4 xl:px-0 pb-24 pt-6 md:pt-0">
        <SectionHeading :title="category?.name" />
        <div class="grid grid-flow-col grid-cols-2 md:grid-cols-4 grid-rows-2 md:grid-rows-1 gap-3 md:gap-4">
            <PodcastCard v-for="podcast in podcasts" :podcast="podcast"/>
        </div>
    </section>


</template>

<script>
    import Layout from '@/Shared/Layout'
    import SectionHeading from '@/Shared/SectionHeading'
    import PodcastCard from '@/Shared/PodcastCard'

    export default {
        props: {
            category: Object,
            podcasts: Object,
        },
        components: { SectionHeading, PodcastCard },
        layout: Layout,
    }
</script>
